<template>
  <div class="relative mr-5">
    <span
      class="align-middle cursor-pointer leading-none"
      @click="toggleMenu()"
    >
      <img
        class="h-6 w-auto max-w-none block"
        :src="require(`@/assets/flags/` + findCurrentLanguage().flag)"
        alt=""
      />
    </span>
    <div
      v-if="menu"
      v-click-away="toggleMenu"
      class="fixed z-20 top-header right-0 text-right"
    >
      <div class="bg-nucleus-white shadow-lg">
        <div
          v-for="(language, index) in languages"
          :key="index"
          class="p-5 opacity-50 hover:bg-gray-50 hover:opacity-100 cursor-pointer transition-all"
          :class="{ 'opacity-100': currentLanguage === language.locale }"
          @click="changeLanguage(language.locale)"
        >
          <img
            class="h-6 w-auto max-w-none block"
            :src="require(`@/assets/flags/` + language.flag)"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { Auth } from "aws-amplify";
import Languages from "@/store/data/languages.json";
import { findLanguage } from "@/utils/languages";

@Options({
  data() {
    return {
      menu: false,
      languages: Languages,
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    toggleMenu() {
      this.menu = this.menu ? false : true;
    },
    changeLanguage(language: string) {
      this.$root.$i18n.locale = language;
      this.$store.dispatch("changeLanguage", language);
      this.persistUserLanguage(language);
      this.menu = false;
    },
    async persistUserLanguage(language: string) {
      const user = this.$store.getters.getUserObject;
      if (user) {
        const currentLanguage = user.attributes["custom:language"];
        if (language !== currentLanguage) {
          await Auth.updateUserAttributes(user, {
            ["custom:language"]: language,
          });
          // console.log("Updated user language attribute to:", language);
          const updatedUser = await Auth.currentAuthenticatedUser({
            bypassCache: true,
          });
          await this.$store.dispatch("setUserObject", updatedUser);
        }
      }
    },
    findCurrentLanguage() {
      return findLanguage(this.currentLanguage);
    },
  },
})
export default class LanguageMenu extends Vue {}
</script>
